import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import topImagePcPng from 'src/images/partner/firstview-pc.jpg'
import topImagePcWebp from 'src/images/partner/firstview-pc.webp'
import topImageSpPng from 'src/images/partner/firstview-sp.jpg'
import topImageSpWebp from 'src/images/partner/firstview-sp.webp'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import ColorButton from 'src/components/atoms/ColorButton'
import { PcSpWidth } from 'src/components/shared/Constant'

  type BgImageProps = {
    src: string
    alt: string
    width: string
    height: string
  }


export const PartnerFirstView = () => {

    return (
        <TopMainView>
                <Picture>
                <source
                    media={`(max-width: ${PcSpWidth.MOBILE_L - 1}px)`}
                    srcSet={topImageSpWebp}
                    type="image/webp"
                />
                <source
                    media={`(min-width: ${PcSpWidth.MOBILE_L}px)`}
                    srcSet={topImagePcWebp}
                    type="image/webp"
                />
                <source
                    media={`(max-width: ${PcSpWidth.MOBILE_L - 1}px)`}
                    srcSet={topImageSpPng}
                />
                <source
                    media={`(min-width: ${PcSpWidth.MOBILE_L}px)`}
                    srcSet={topImagePcPng}
                />
                    <BgImage
                    src={topImagePcPng}
                    alt=""
                    width="2324"
                    height="1340"
                    />
                </Picture>
                <TopContents>
                    <CatchPhrase>
                    <h2>
                        <div>commmune</div>
                        <div>販売代理店・販売パートナー募集</div>
                    </h2>
                    <CatchPhraseSecond>日本一選ばれているコミュニティプラットフォームで<br/>広がるビジネスチャンス</CatchPhraseSecond>
                    </CatchPhrase>
                    <ColorButton
                        text="お問合せはこちら"
                        to="/partner#info"
                        size="medium"
                        arrow={false}
                    />
            </TopContents>
        </TopMainView>
    )
}

const TopMainView = styled.div`
    overflow: hidden;
    max-height: calc(900px - 60px - 65px);
    position: relative;
    z-index: 1;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        height: min(45.5vw, 570px);
        min-height: auto;
        max-height: none;
        padding: 0;
        position: relative;
        align-items: center;
    }
`

const TopContents = styled.div`
    position: relative;
    align-items: center;
    height: 100%;
    margin: 20% auto 5%;
    text-align: center;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        height: auto;
        display: block;
        margin: 7% auto;
    }
`
const CatchPhrase = styled(Typography)`
    color: ${Styles.color.grayscale[100]};
    font-weight: ${Styles.fontWeight.semiBold};
    line-height: ${Styles.lineHeight[400]};
    letter-spacing: ${Styles.letterSpacing[400]};
    text-align: center;
    margin: 0 auto 5vh;
    font-size: min(8vw, ${Styles.fontSize[600]});
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        margin-bottom: 5%;
        font-size: min(4vw, ${Styles.fontSize[900]});
    }
    @media screen and (min-width: ${BreakPoint.LAPTOP}) {
        margin-bottom: 10vh;
    }
`

const CatchPhraseSecond = styled(Typography)`
        font-size: min(8vw, ${Styles.fontSize[300]});
    }
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        font-size: min(8vw, ${Styles.fontSize[600]});
    }
`

const Picture = styled.picture`
    height: 100%;
    display: block;
    text-align: center;
    position: absolute;
`

const BgImage = styled.img<BgImageProps>`
    height: auto;
    width: 100vw;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        max-height: none;
        width: 100vw;
        height: auto;
    }
`